module.exports = __webpack_public_path__ + "static/dieRoboter_panel-0556864365e98d0f824dc7f01f2561f3.png";